import React from 'react'
import { string } from 'prop-types'
import { useAtSize } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useInnerTileVisuals } from '../hooks/hooks'

export default function TileText({ icon, color, title, header, subHeading }) {
  const atSize = useAtSize()
  let iconBgColor = ''
  switch (color) {
    case '#bed21e':
      iconBgColor = '#318d43'
      break
    case '#6db344':
      iconBgColor = '#235c35'
      break
    case '#01b6d1':
      iconBgColor = '#01496e'
      break
    case '#7de3f4':
      iconBgColor = '#006184'
      break
    case '#ffb81c':
      iconBgColor = '#d45311'
      break
    case '#f68d2e':
      iconBgColor = '#a43500'
      break
    case '#fc4e6d':
      iconBgColor = '#8f124a'
      break
    default:
      break
  }
  const iconCss = css`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: ${iconBgColor};
    width: 60px;
    height: 60px;
    margin: ${atSize({ default: '40px 0 0 20px', lg: '40px 0 0 32px' })};
  `
  const tileTitleCss = css`
    font-family: 'Noto Sans', sans-serif;
    font-size: 14px;
    font-weight: bold;
    color: ${iconBgColor};
    text-align: start;
    margin: ${atSize({ default: '12px 0 0 20px', lg: '12px 0 0 32px' })};
    text-transform: uppercase;
  `
  const tileHeaderCss = css`
    font-size: ${atSize({ default: '30px', lg: '34px' })};
    font-family: 'museo', serif;
    color: #212225;
    text-align: start;
    margin: ${atSize({
      default: `20px 20px ${subHeading ? '10px' : '40px'} 20px`,
      lg: `20px 32px ${subHeading ? '10px' : '40px'} 32px`,
    })};
  `
  const subHeadingCss = css`
    font-size: 1rem;
    color: #212225;
    text-align: start;
    margin: ${atSize({ default: '0px 10px 40px 20px', lg: '0px 10px 40px 32px' })};
  `
  const tileImage = useInnerTileVisuals(icon, color)

  return (
    <>
      <div css={iconCss}>{tileImage.icon}</div>
      <p css={tileTitleCss}>{title}</p>
      <p css={tileHeaderCss}>{header}</p>
      {subHeading && <p css={subHeadingCss}>{subHeading}</p>}
    </>
  )
}

TileText.propTypes = {
  icon: string,
  color: string,
  title: string,
  header: string,
  subHeading: string,
}
